import { fCurrency } from "../../../../../utils/formatNumber";

const currencyCols = ["OriginalPrice", "Tax", "Shipping", "UnitPrice"];

export const parseLogItems = (logItems) => logItems.map(item => {
  if (item.type === "Update" || item.tableName === "InvoiceItem") {
    return {
      ...item,
      columnChanges: item.columnChanges.map(change => ({
        ...change,
        oldValue: currencyCols.includes(change.columnName) ? fCurrency(change.oldValue) : change.oldValue,
        newValue: currencyCols.includes(change.columnName) ? fCurrency(change.newValue) : change.newValue
      }))
    };
  }
  return item;
});

export const getItemDescription = (itemQuantityId, items) => {
  const orderItem = items?.find((item) => item.id === itemQuantityId);
  return orderItem?.description || `Item ${itemQuantityId}`;
};

export const listItemStyles = {
  color: "#637381",
  fontSize: '12px'
}